
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import HowXt from './HowXt.vue'
import NoBasic from './NoBasic.vue'
import Uninsist from './Uninsist.vue'
import { EnumWelcomeAskCompType } from '@xt/client/enums/activity/index'
import { Observer } from 'mobx-vue'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types'

@Observer
@Component({
  components: {
    LazyImg,
    HowXt,
    NoBasic,
    Uninsist
  }
})
export default class WelcomeAsk extends Vue {
  @Prop({ required: true }) readonly dataSource: CalligraphyLevel2JsonResp

  current: EnumWelcomeAskCompType = EnumWelcomeAskCompType.NoBasic
  tabList: EnumWelcomeAskCompType[] = [EnumWelcomeAskCompType.NoBasic, EnumWelcomeAskCompType.Uninsist, EnumWelcomeAskCompType.HowXt]

  get EnumWelcomeAskCompType() {
    return EnumWelcomeAskCompType
  }

  onSelect(t: EnumWelcomeAskCompType) {
    if (this.current === t) return
    this.current = t
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
